module.exports = __webpack_public_path__ + "media/images/emblems/Zuzwilsg-4f8d518943b9898e9fe0b48ca1420296.png";